<template>
  <div class="sm:col-span-4">
    <label class="block text-sm font-medium text-gray-700">Straße</label>
    <div class="mt-1 relative">
      <input type="text"
             v-model="streetName"
             @blur="tenant.validateField(streetNameField, streetName)"
             id="streetName"
             class="shadow-sm focus:ring-blue-700 focus:border-blue-700 placeholder-gray-400 block w-full sm:text-sm border-gray-400 rounded-md"
             aria-invalid="false"
             placeholder="Musterstraße"
      >
    </div>
    <p v-if="tenant.errors[streetNameField]" class="mt-2 text-sm text-red-600 error-message">{{ tenant.errors[streetNameField] }}</p>
  </div>

  <div class="sm:col-span-2">
    <label class="block text-sm font-medium text-gray-700">Hausnr.</label>
    <div class="mt-1 relative">
      <input type="text"
             v-model="houseNumber"
             @blur="tenant.validateField(houseNumberField, houseNumber)"
             id="houseNumber"
             class="shadow-sm focus:ring-blue-700 focus:border-blue-700 placeholder-gray-400 block w-full sm:text-sm border-gray-400 rounded-md"
             aria-invalid="false"
             placeholder="21"
      >
    </div>
    <p v-if="tenant.errors[houseNumberField]" class="mt-2 text-sm text-red-600 error-message">{{ tenant.errors[houseNumberField] }}</p>
  </div>

  <div class="sm:col-span-3">
    <label class="block text-sm font-medium text-gray-700">PLZ</label>
    <div class="mt-1 relative">
      <input type="text"
             v-model="addressCode"
             @blur="tenant.validateField(addressCodeField, addressCode)"
             id="addressCode"
             class="shadow-sm focus:ring-blue-700 focus:border-blue-700 placeholder-gray-400 block w-full sm:text-sm border-gray-400 rounded-md"
             aria-invalid="false"
             placeholder="21234"
      >
    </div>
    <p v-if="tenant.errors[addressCodeField]" class="mt-2 text-sm text-red-600 error-message">{{ tenant.errors[addressCodeField] }}</p>
  </div>

  <div class="sm:col-span-3">
    <label class="block text-sm font-medium text-gray-700">Stadt</label>
    <div class="mt-1 relative">
      <input type="text"
             v-model="city"
             @blur="tenant.validateField(cityField, city)"
             id="city"
             class="shadow-sm focus:ring-blue-700 focus:border-blue-700 placeholder-gray-400 block w-full sm:text-sm border-gray-400 rounded-md"
             aria-invalid="false"
             placeholder="Berlin"
      >
    </div>
    <p v-if="tenant.errors[cityField]" class="mt-2 text-sm text-red-600 error-message">{{ tenant.errors[cityField] }}</p>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useTenantStore } from '../stores/tenant';
import { addressFieldsMap } from "../stores/address";

const props = defineProps({
  addressType: {
    type: String,
    required: true,
    validator: (value) => ['tenant', 'property', 'landlord'].includes(value)
  }
});

const tenant = useTenantStore();

const addressCodeField = computed(() => addressFieldsMap[props.addressType].addressCode);
const cityField = computed(() => addressFieldsMap[props.addressType].city);
const streetNameField = computed(() => addressFieldsMap[props.addressType].streetName);
const houseNumberField = computed(() => addressFieldsMap[props.addressType].houseNumber);

const addressCode = computed({
  get: () => tenant.formValues[addressCodeField.value],
  set: (value) => tenant.setFormValue(addressCodeField.value, value)
});

const city = computed({
  get: () => tenant.formValues[cityField.value],
  set: (value) => tenant.setFormValue(cityField.value, value)
});

const streetName = computed({
  get: () => tenant.formValues[streetNameField.value],
  set: (value) => tenant.setFormValue(streetNameField.value, value)
});

const houseNumber = computed({
  get: () => tenant.formValues[houseNumberField.value],
  set: (value) => tenant.setFormValue(houseNumberField.value, value)
});

</script>
